import React from 'react';
import { useLocation } from 'react-router-dom';
import { SycaiLogo } from './BrandIcons';

export function StudyListBrand(): JSX.Element {
  const { pathname } = useLocation();

  return (
    <div className="flex items-center gap-6">
      <SycaiLogo />
      {pathname === '/' ? (
        <span className="text-foreground text-[20px] font-medium">Study List</span>
      ) : null}
    </div>
  );
}

export default StudyListBrand;
